export default __webpack_public_path__ + "static/media/RMS-scale.2e47152d.png";